import { FC } from 'react';

import { Modifier } from 'features/menu/components/product-detail/modifier/modifier';
import { IModifierData } from 'features/menu/components/product-detail/modifier/types';
import { SelectModifierFn } from 'features/menu/components/product-detail/product-customization/types';

import { ListCardGroup } from 'components/list-card-group';
import { useModifierRedesignExperiment } from 'experiments/use-modifier-redesign-phase-one';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';

import { ModifierExperiment } from '../modifier/experiment/modifier';

export interface IModifierGroup {
  key: string;
  displayGroupName?: TranslationKey;
  modifiers: IModifierData[];
}

export type IModifierGroupProps = IModifierGroup & {
  onModifierSelectionChange: SelectModifierFn;
};

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
}) => {
  const enableModifierRedesign = useModifierRedesignExperiment();
  const ModifierComponent = enableModifierRedesign ? ModifierExperiment : Modifier;

  return (
    <ListCardGroup
      items={modifiers}
      header={displayGroupName ? t(displayGroupName) : undefined}
      renderItem={({ item: modifierProps }: { item: IModifierData }) => (
        <ModifierComponent
          {...modifierProps}
          key={`modifier-${modifierProps.modifier.id}`}
          onSelectionsChange={selections =>
            onModifierSelectionChange(selections, modifierProps.modifier)
          }
        />
      )}
    />
  );
};
